import Paginator from '@/models/Paginator'
import { assetTransfer as backend } from '@/api'

let countSeq = 0

let assetTransfer = {

  namespaced: true,

  state: {
    transfers: new Paginator,
    transferCount: null,
    countLoading: false,
    countError: false,
  },

  mutations: {
    setTransfers: (state, payload) => state.transfers = payload,
    setTransferCount: (state, payload) => state.transferCount = payload,
    setCountLoading: (state, loading) => state.countLoading = loading,
    setCountError: (state, val) => state.countError = val,
    clear: (state) => {
      state.transfers = new Paginator
      state.transferCount = null
      state.countLoading = false
      state.countError = false
    },
  },

  actions: {
    loadReport: ({ commit }, payload) => new Promise((resolve, reject) => {
      backend.loadReport(payload, ({ data }) => {
        commit('setTransfers', data)
        resolve()
      }, error => reject(error))
    }),

    loadCount: ({ commit }, params) => {
      const seq = ++countSeq
      commit('setTransferCount', null)
      commit('setCountLoading', true)
      commit('setCountError', false)
      return backend.loadCount(params)
        .then(({ data }) => { if (seq === countSeq) commit('setTransferCount', data) })
        .catch(() => { if (seq === countSeq) commit('setCountError', true) })
        .finally(() => { if (seq === countSeq) commit('setCountLoading', false) })
    },
  },

  getters: {
    transfers: state => state.transfers,
    countLoading: state => state.countLoading,
    countError: state => state.countError,
    transferCount: state => state.transferCount,

    paginable: state => {
      if (!state.transferCount || !state.transfers.links) return state.transfers

      const { total, last_page } = state.transferCount
      const anyLink = state.transfers.links.next || state.transfers.links.prev

      let firstLink = null
      let lastLink = null

      if (anyLink) {
        try {
          const firstUrl = new URL(anyLink)
          firstUrl.searchParams.set('page', 1)
          firstLink = firstUrl.toString()

          const lastUrl = new URL(anyLink)
          lastUrl.searchParams.set('page', last_page)
          lastLink = lastUrl.toString()
        } catch (e) { /* leave null */ }
      }

      return {
        ...state.transfers,
        meta: { ...state.transfers.meta, total, last_page },
        links: { ...state.transfers.links, first: firstLink, last: lastLink },
      }
    },
  }

}

export default assetTransfer
